export default function setTextAccCommentPlanerAction(commentPlaner) {
    return {
        type: 'SET_COMMENT_PLANER',
        payload: commentPlaner
    }
}